import { useEffect, useRef } from 'react';

const GoogleLoginButton = ({ onSuccess, onError, disabled = false }) => {
  const buttonRef = useRef(null);
  const initialized = useRef(false);

  const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID";

  useEffect(() => {
    // Load Google Identity Services script
    if (!window.google && !document.querySelector('script[src*="accounts.google.com"]')) {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      script.onload = initializeGoogleSignIn;
    } else if (window.google) {
      initializeGoogleSignIn();
    }

    return () => {
      // Cleanup if needed
    };
  }, []);

  const initializeGoogleSignIn = () => {
    if (window.google && !initialized.current && buttonRef.current) {
      try {
        window.google.accounts.id.initialize({
          client_id: CLIENT_ID,
          callback: handleCredentialResponse,
          auto_select: false,
          cancel_on_tap_outside: true,
        });

        window.google.accounts.id.renderButton(buttonRef.current, {
          theme: 'outline',
          size: 'large',
          width: '100%',
          text: 'signin_with',
          shape: 'rectangular',
          logo_alignment: 'left',
        });

        initialized.current = true;
      } catch (error) {
        console.error('Error initializing Google Sign-In:', error);
        onError && onError(error);
      }
    }
  };

  const handleCredentialResponse = async (response) => {
    try {
      if (!response.credential) {
        throw new Error('No credential received from Google');
      }

      // Decode the JWT token to get user information
      const decodedToken = parseJwt(response.credential);
      
      const userData = {
        googleId: decodedToken.sub,
        email: decodedToken.email,
        name: decodedToken.name,
        picture: decodedToken.picture,
        emailVerified: decodedToken.email_verified,
        credential: response.credential,
      };

      onSuccess && onSuccess(userData);
    } catch (error) {
      console.error('Error handling Google Sign-In response:', error);
      onError && onError(error);
    }
  };

  // Helper function to decode JWT token
  const parseJwt = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error parsing JWT token:', error);
      throw new Error('Invalid token format');
    }
  };

  return (
    <div className="google-login-container" style={{ width: '100%', marginBottom: '1rem' }}>
      <div
        ref={buttonRef}
        style={{
          display: disabled ? 'none' : 'block',
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
        }}
      />
      {disabled && (
        <div className="google-login-disabled" style={{
          padding: '12px',
          border: '1px solid #dadce0',
          borderRadius: '8px',
          textAlign: 'center',
          color: '#5f6368',
          backgroundColor: '#f8f9fa',
        }}>
          Google Sign-In temporarily disabled
        </div>
      )}
    </div>
  );
};

export default GoogleLoginButton;
